import React, { useEffect, useLayoutEffect } from 'react';
import CheckboxInput from '../CheckboxInput';
const TypesProcessedAndStoredCheck = _ref => {
  let {
    value,
    options,
    onChange,
    isDataProcessed,
    isDataStored,
    // typesOfDataStored,
    fieldName
  } = _ref;
  useLayoutEffect(() => {
    // On initial render, when the root question is true and the initial value this question is false,
    // onChange is triggred to render the dependent question of `typesofDataProcessed`
    if (isDataProcessed && value === undefined) {
      onChange(false);
    }
  }, []);
  useEffect(() => {
    // If the checkbox is selected, and the aove question of datastored is changed to false, the checkbox is disabled
    // This will ensure that the value of checkbox is also changed to false in this case.
    if (isDataStored === false && value === true) {
      onChange(false);
    }
  }, [isDataStored, value]);
  if (!isDataStored || isDataProcessed === false) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CheckboxInput, {
    value: value,
    options: options,
    onChange: onChange,
    fieldName: fieldName
  });
};
export default TypesProcessedAndStoredCheck;